import React, { useState, useEffect } from 'react'
import imgProduct from '../../assets/image/Product.png'
import "./Product.scss";
import axios from 'axios';
import { useHistory  } from 'react-router-dom';
const Product = () => {
    const history = useHistory();
    const [Products, setProducts] = useState([])
    const [Category, setCategory] = useState([])
    const [Class, setClass] = useState([])
    const [filter,setFilter] = useState([]);
    const getGetProductsByMachine = async () => {
        await axios.get('https://komatsu-api.dev.fysvc.com/api/v1/GetProductsByMachine?machine_id=0').then(async (response) => {
            await setProducts(response.data.data)
            return response.data.data
        })
    }
    const getGetMachines = async () => {
        await axios.get('https://komatsu-api.dev.fysvc.com/api/v1/GetMachines').then(async (response) => {
            await setCategory(response.data.data)
            return response.data.data
        })
    }
    useEffect(() => {
        getGetProductsByMachine()
        getGetMachines()
        getFilterProduct(filter)
    }, [filter])
    const onHandleChange = async (e) =>{
        const {name,value} = e.target
        let item = {...filter,[name]:value}
        setFilter(item)
        if(name == 'machines'){
          setClass("")
          getGetClasses(value)
        }
        
    }
    const getGetClasses = async (id) => {
        await axios.get('https://komatsu-api.dev.fysvc.com/api/v1/GetClasses?machine_id='+id).then(async (response) => {
            await setClass(response.data.data)
            return response.data.data
        })
    }
    const getFilterProduct = async (data) => {
        if(data.length != 0){
            console.log(data)
        //    await axios.get('https://komatsu-api.dev.fysvc.com/api/v1/GetClasses?machine_id='+id).then(async (response) => {
        //         await setClass(response.data.data)
        //         return response.data.data
        //     })
        }else{
            return false
        }
        
    }
    const onAddProductsCompare = async (dataProducts) =>{
        let dataProduct = []
        var dataProductCompare = JSON.parse(localStorage.getItem('dataProductCompare'))
        if(dataProductCompare == null){
            dataProduct.push(dataProducts)
        }else{
            dataProduct.push(...dataProductCompare,dataProducts)
        }
        const arrayUniqueByKey = await [...new Map(dataProduct.map(item => [item['id'], item])).values()];
        localStorage.setItem("dataProductCompare", JSON.stringify(arrayUniqueByKey))
        history.push('/Compare');
    }
    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col">
                    {/* <div className='group_search'>
                        <div className='box_search group_search_left'>
                            <select className="" name="machines" onChange={(e) => onHandleChange(e)} >
                                <option>Select Class</option>
                                {
                                    Category.length != 0 && Category.map((category, i)=>{
                                       return <option value={category.id} >{category.name}</option>
                                    })
                                }
                            </select>
                        </div>
                        <div className='box_search group_search_right'>
                            <select className="" name="classes" onChange={(e) => onHandleChange(e)}>
                                <option>Select Class</option>
                                {
                                    Class.length != 0 && Class.map((classItem, i)=>{
                                       return <option value={classItem.id} >{classItem.name}</option>
                                    })
                                }
                            </select>
                        </div>
                    </div> */}
                    <div className='container_product_item'>
                        <div className='group_products'>
                            {
                                Products.length != 0 && Products.map((product, i) => {
                                    return (
                                        <div className='product_item' onClick={() => onAddProductsCompare(product)}>
                                            <div className="group_product_img">
                                                <img src={product.image_path} className="img_product"></img>
                                            </div>
                                            <div className="detail">
                                                <div className='title'>{product.name}</div>
                                                <div className='sub'>{product.machinename}</div>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Product